import { ReactNode } from "react"

type Props = {
  title: string
  description: string
  headerAction?: ReactNode
  children: ReactNode
}

export function BackofficeKnowledgeSection({ title, description, headerAction, children }: Props) {
  return (
    <section className="rounded-lg border bg-card">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b px-4 py-3">
        <div>
          <h2 className="font-semibold">{title}</h2>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        {headerAction}
      </div>
      <div className="overflow-x-auto">{children}</div>
    </section>
  )
}
